import React from 'react';
import styles from 'v2/common/Activity/activityAssociations.module.scss';
import { ActivityAssociation, File } from 'v2/models';
import ActivityAssociationCheckbox from '../ActivityAssociationCheckbox/ActivityAssociationCheckbox';

export interface ActivityAssociationCategoryProps {
  label: string;
  associationList: ActivityAssociation[];
  checkedAssociations: Array<ActivityAssociation>;
  file: File | undefined;
  activityType?: string;
  checkBoxChanged: (
    isChecked: boolean,
    association: ActivityAssociation
  ) => void;
}

const ActivityAssociationCategory = ({
  label,
  associationList,
  checkedAssociations,
  file,
  activityType,
  checkBoxChanged,
}: ActivityAssociationCategoryProps) => {
  return (
    <div
      key={label}
      className="flex flex-row mb-4"
      data-cy={`associations:category_${label}`}
    >
      <p className={styles.categoryTitle} data-testid={`${label}`}>
        {label}
      </p>
      {associationList.map((association) => (
        <ActivityAssociationCheckbox
          key={`${association.table_name}_${association.object_id}`}
          association={association}
          checkedAssociations={checkedAssociations}
          file={file}
          activityType={activityType}
          checkBoxChanged={checkBoxChanged}
        />
      ))}
    </div>
  );
};

export default ActivityAssociationCategory;
